import React, { Component } from 'react';
import flatpickr from 'flatpickr';
import classNames from 'classnames';

import {
  prettyKey,
  formatDateWithoutTimeForAPI,
  formatDateForAPI,
} from '../helpers/formatters';

import 'flatpickr/dist/themes/material_blue.css';

const hooks = [
  'onOpen',
  'onClose',
  'onMonthChange',
  'onYearChange',
  'onReady',
  'onValueUpdate',
  'onDayCreate',
];

export default class DateTimePicker extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.flatpickr = null;
  }

  componentDidMount = () => {
    this.createFlatpickrElement();
  };

  createFlatpickrElement = () => {
    const extraOptions = this.props?.options?.enableTime
      ? {
          altInput: true,
          altFormat: 'm/d/Y H:i K',
        }
      : {};
    const options = {
      onClose: this.handleClose,
      onChange: this.handleChange,
      ...extraOptions,
      ...this.props.options,
    };

    hooks.forEach((hook) => {
      if (this.props[hook]) {
        options[hook] = this.props[hook];
      }

      if (this.props.input[hook]) {
        options[hook] = this.props.input[hook];
      }
    });

    const timer = setInterval(() => {
      if (this.ref && !this.ref.current) {
        return;
      }

      this.flatpickr = flatpickr(this.ref.current, options);
      clearInterval(timer);
    }, 32);
  };

  formatDate = (value) => {
    if (this.props?.options?.enableTime) {
      return formatDateForAPI(value);
    }

    if (Array.isArray(value)) {
      return formatDateWithoutTimeForAPI(value);
    }

    if (value instanceof Date) {
      return formatDateWithoutTimeForAPI(value);
    }

    return formatDateWithoutTimeForAPI(new Date(value));
  };

  handleChange = (event) => {
    const {
      input: { onChange },
    } = this.props;

    if (Array.isArray(event)) {
      return onChange(this.formatDate(event[0]));
    }

    return onChange(this.formatDate(event));
  };

  handleClose = (event) => {
    this.ref.current.blur();
  };

  get placeholder() {
    const { placeholder } = this.props;
    return placeholder || 'Select date...';
  }

  render() {
    const {
      input,
      input: { name },
      required,
      disabled,
      label,
      placeholder,
      meta: { touched, error },
      onChange,
      subText,
      ...rest
    } = this.props;

    return (
      <div
        className={classNames({
          'form-group': true,
          'datetime-picker': true,
          'has-error': touched && error,
          'has-success': touched && !error,
        })}
      >
        <label className="control-label">
          {label ? label : prettyKey(name)} {required ? '*' : ''}
        </label>
        <input
          {...input}
          value={this.formatDate(input.value)}
          type="text"
          className="form-control"
          style={{ backgroundColor: disabled ? '#eee' : '#fff' }}
          placeholder={this.placeholder}
          ref={this.ref}
          disabled={disabled}
          {...rest}
        />
        {subText && <span>{subText}</span>}
        {touched && error && <span className="help-block">{error}</span>}
      </div>
    );
  }
}
